import React from 'react';
import i18n from 'i18';
import { EmptyWalletTransparentBulkIcon } from 'icons-lib';
import { Box, Typography } from '@mui/material';
import { AppDataContext } from '../../context/Context';
import PropTypes from 'prop-types';
import SearchBox from '../../search-box/SearchBox';
import { tNameFieldToCamelCase } from '../../utils/formatName';

////////////////////////////

const wallet = <EmptyWalletTransparentBulkIcon />;

export default class DialogWalletArrayField extends React.Component {
    static contextType = AppDataContext;

    handleChangeAssociation = (value) => {
        this.props.onChange(this.props.field.id, value);
    };

    render() {
        let contextItems =
            this.context.getState().controllersData?.[this.props.field.from] ||
            [];
        let totalCount = this.context.getState().controllersData?.[this.props.field.from + 'TotalCount'] || 0;
        const items = contextItems.map((item) => {
            if (!item.walletNumber) return item;
            return {
                ...item,
                id: item.walletNumber
            };
        });

        const {
            label,
            required,
            multiple,
            primary,
            secondary,
            primaryType,
            secondaryType,
            from
        } = this.props.field;

        const translatedLabel = i18n.t('columns.' + label);
        const primaryTitle = i18n.t(
            'columns.' + tNameFieldToCamelCase(primary)
        );
        const secondaryTitle = i18n.t(
            'columns.' + tNameFieldToCamelCase(secondary)
        );
        const addAssociationLabel = i18n.t('buttons.' + label + 'Add');
        const translatedSearchLabel = from
            ? i18n.t('pages.' + from + '.title')
            : '';

        const requiredLabel = required ? ' *' : '';

        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">
                    {translatedLabel + requiredLabel}
                </Typography>
                <SearchBox
                    serverSearch={this.props.field.searchType === 'server'}
                    searchFields={this.props.field.searchFields}
                    searchController={this.props.field.searchController}
                    handleChange={(value) =>
                        this.handleChangeAssociation(value)
                    }
                    icon={wallet}
                    translatedLabel={translatedLabel}
                    multiple={multiple}
                    value={this.props.value}
                    primaryTitle={primaryTitle}
                    secondaryTitle={secondaryTitle}
                    primaryKey={primary}
                    secondaryKey={secondary}
                    primaryType={primaryType}
                    secondaryType={secondaryType}
                    items={items}
                    wrapperRef={this.props.wrapperRef}
                    addAssociationLabel={addAssociationLabel}
                    translatedSearchLabel={translatedSearchLabel}
                    totalItemsCount={totalCount}
                    replaceId="walletNumber"
                />
            </Box>
        );
    }
}
DialogWalletArrayField.propTypes = {
    field: PropTypes.object.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    data: PropTypes.object,
    wrapperRef: PropTypes.object
};
